import { ref, push, set, onValue, get } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'
import { sellStock, receiveStock } from './products.js'

// Point-of-Sale transactions. /club/sales. Feeds Sales Today, member
// purchases (Member 360), and reports.
//   {id}: { memberId, lines:[{productId,name,qty,price}], subtotal, discount,
//           tax, total, tenders:[{type,amount,ref}], type, employeeId, timestamp }
const BASE = 'club/sales'

export function watchSales(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }
export async function getSalesOnce() { return (await get(tref(BASE))).val() || {} }

export const isToday = (ts) => new Date(ts).toDateString() === new Date().toDateString()

// Records a sale and decrements inventory for each product line. Tender-side
// redemptions (shop credit / gift card) are performed by the caller (POS)
// because they need the specific account/card ids; the card tender is a STUB
// (records the amount, never charges — WIRE PROCESSOR HERE LATER).
export async function recordSale(sale) {
  const node = push(tref(BASE))
  const rec = { id: node.key, memberId: sale.memberId || null, lines: sale.lines || [], subtotal: Number(sale.subtotal) || 0, discount: Number(sale.discount) || 0, tax: Number(sale.tax) || 0, total: Number(sale.total) || 0, tenders: sale.tenders || [], type: sale.type || 'sale', employeeId: sale.employeeId || null, timestamp: Date.now() }
  await set(node, rec)
  for (const ln of rec.lines) if (ln.productId) { const cur = (await get(tref(`club/products/${ln.productId}/quantity`))).val(); await sellStock(ln.productId, ln.qty, cur) }
  logActivity({ type: 'sale', memberId: rec.memberId, icon: '🛒', text: `Sale ${rec.total < 0 ? 'refund' : 'rung'}: $${Math.abs(rec.total).toFixed(2)} (${rec.lines.length} item${rec.lines.length === 1 ? '' : 's'})` })
  return node.key
}

// Return: mirror of a prior sale — negative total, re-increments inventory.
export async function recordReturn(sale) {
  const node = push(tref(BASE))
  const rec = { id: node.key, memberId: sale.memberId || null, lines: sale.lines || [], subtotal: -(Math.abs(Number(sale.subtotal) || 0)), discount: 0, tax: -(Math.abs(Number(sale.tax) || 0)), total: -(Math.abs(Number(sale.total) || 0)), tenders: sale.tenders || [], type: 'return', employeeId: sale.employeeId || null, originalId: sale.originalId || null, timestamp: Date.now() }
  await set(node, rec)
  for (const ln of rec.lines) if (ln.productId) { const cur = (await get(tref(`club/products/${ln.productId}/quantity`))).val(); await receiveStock(ln.productId, ln.qty, 'Return', cur) }
  logActivity({ type: 'sale', memberId: rec.memberId, icon: '↩️', text: `Return: $${Math.abs(rec.total).toFixed(2)}` })
  return node.key
}
